import { ReactNode } from "react";

export interface CommonTemplateProps {
    children?: ReactNode
}

export function CommonTemplate({ children }: CommonTemplateProps) {

    // logger.debug(role)
    return <>
        {children}
    </>
}
